import React from "react";
import { Card, CardBody } from "reactstrap";

const ProfileAllScrappedDataLoader = ({ height }) => {
  return (
    <Card style={{ height: `${height}px`, borderRadius: "9px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }}>
      <CardBody>
        {/* <Skeleton width={100} style={{ backgroundColor: "#f1f1f1", marginBottom: "1rem" }} />
        <Skeleton style={{ backgroundColor: "#f1f1f1", height: "100%" }} /> */}
      </CardBody>
    </Card>
  );
};

export default ProfileAllScrappedDataLoader;
